import axios from "../../../api/axios";

export const fetchWadaPatras = async (id) => {
    return axios.get(`/citizen-charter?section_id=${id}`).then(res=>res.data)
}

export const fetchWadaPatraById = async (id) => {
    return axios.get(`/citizen-charter?id=${id}`).then(res=>res.data)
}
